import { Box, Checkbox, FormControlLabel, Grid, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotificationCount } from '../../../action/searchFilterAction';
import AHMIS, { API_URL } from '../../../api/api';
import AddAlertMessage from '../../../components/alert/Alert';
import CustomReactSelect from '../../../components/custom-react-select/CustomReactSelect';
import DeleteRegisterRecordConformation from '../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation';
import CustomModal from '../../../components/modal/CustomModal';
import MulDartaaSelect from '../../../components/mul-dartaa-select/MulDartaaSelect';
import PendingPatientList from '../../../components/pending-patient-list/PendingPatientList';
import RegisterNotificationBell from "../../../components/notification/RegisterNotificationBell";
import { useNotificationAccept } from "../../../components/notification/useNotificationAccept";
import RegisterHeader from '../../../components/register-header/RegisterHeader';
import { AppMisc } from '../../../misc/appMisc';
import { ERROR, HOMEOPATHY, ROW_PER_PAGE, REQUIRED_FIELD, SOMETHING_WENT_WRONG, SUCCESS, NOTIFICATION_ACCEPTED } from '../../../utils/constants';
import { ICD_CODE_OPTIONS, MUL_DARTA_NUMBERS_LIST } from '../../../utils/constants/forms';
import { DateUtils } from '../../../utils/dateUtils';
import { SessionStorage } from '../../../utils/storage/sessionStorage';
import HomeoPathySewaRegister from '../../users/components/register/homeo-pathy-sewa-register/HomeoPathySewaRegister';
import { fetchPendingNotifications } from "../../../components/notification/notificationService";

const HomeoPathyForm = () => {

  const [modalTitle, setModalTitle] = useState("होमियोप्याथी सेवा राजिस्टर रेकर्ड थप्नुहोस्।");
  const [showHomeoPathyModal, setShowHomeoPathyModal] = useState(false)
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const [homeoPathyDataTable, setHomeoPathyDataTable] = useState([]);
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch, control } = useForm();
  const [totalSize, setTotalSize] = useState();
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const [showHomeopathyDeleteModal, setShowHomeopathyDeleteModal] = useState(false);
  const [homeoPathyDeleteId, setHomePathyDeleteId] = useState(null);
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);
  const dispatch = useDispatch();
  const [pendingPatientList, setPendingPatientList] = useState([])

  const { handleAccept: handleNotificationAccept, addNotificationId } = useNotificationAccept({
    reset,
    setModalOpen: setShowHomeoPathyModal,
    setModalDefaultValues,
    transform: (data) => {
      if (data.palikaName) {
        data.palikaName = AppMisc.getMunicipalityName(data.palikaName);
      }
      return data;
    },
  });

  const openHomeopathyModal = () => {
    setShowHomeoPathyModal(true);
  }

  const closeHomeopathyModal = () => {
    reset({
      icdCode: [],
      diagnosticTest: "",
      possibleDiagnosis: "",
      treatmentAndAdvice: "",
      referredIn: "",
      referredOut: "",
      genderViolence: "",
      patientFirstName: "",
      patientLastName: "",
      age: "",
      wardNumber: "",
      phoneNumber: "",
      nid: "",
      gaunOrTole: "",
      sewaDartaaNumber: "",
    });
    setShowHomeoPathyModal(false);
    setModalDefaultValues()
  }

  useEffect(() => {
    if (fromDate && toDate) {
      getHomeoPathyData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage])

  const getHomeoPathyData = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.homeoPathy}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(pageNumber))}&rowSize=${rowsPerPage}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then((response) => {
        let jsondata = response.data;
        setHomeoPathyDataTable(jsondata?.data?.objectList || []);
        setHomeoPathyDataTable(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.size)
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const handleCustomReactSelectChange = (name, value) => {
    if (name === "icdCode") {
      const selectedValue = ICD_CODE_OPTIONS
        .flatMap((type) => type.options)
        .find((option) => option.label === value)?.value || value;

      setValue(name, selectedValue);
    } else {
      setValue(name, value);
    }
  };

  const handleChecked = (e) => {
    setValue("genderViolence", e.target?.checked);
  };

  const submitHomeopathyRegister = (data) => {
    const isFromNotification = !!modalDefaultValues?.notificationId;
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    data = addNotificationId(data);
    AHMIS.post(API_URL.homeoPathy, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closeHomeopathyModal();
          homeoPathyPendingPatient()
          getHomeoPathyData(fromDate, toDate)
          attachMulDartaaOptions();
          if (isFromNotification) {
            dispatch(fetchNotificationCount(HOMEOPATHY));
          }
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    getHomeoPathyData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const HomeopathyEdit = (id) => {
    AHMIS.get(API_URL.homeoPathy + "/" + id)
      .then((response) => {
        const data = response?.data?.data;
        data.icdCode = AppMisc.getLabelFromValues(ICD_CODE_OPTIONS, data.icdCode);
        setModalDefaultValues(data);
        setShowHomeoPathyModal(true);
        if (data) {
          Object.keys(data).forEach((key) => setValue(key, data[key]));
        }
      })
      .catch(() =>
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG }));
  };



  const closeHomeoPathyDeleteModal = () => {
    setShowHomeopathyDeleteModal(false);
    setHomePathyDeleteId(null);
  }

  const onDeleteHomeoPathyRow = (id) => {
    setShowHomeopathyDeleteModal(true);
    setHomePathyDeleteId(id);
  }

  const deleteHomeoPathyRow = (data) => {
    AHMIS.delete(API_URL.homeoPathy + "/" + homeoPathyDeleteId + "?deletedReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowHomeopathyDeleteModal(false);
          setHomePathyDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getHomeoPathyData(fromDate, toDate)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?sewaType=9&fiscalYear=" + DateUtils.getCurrentFiscalYear() + "&registerConstant=" + HOMEOPATHY)
      .then(response => {
        let data = response.data?.data || [];
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      })
  }

  useEffect(() => {
    attachMulDartaaOptions();
  }, [])

  useEffect(() => {
    homeoPathyPendingPatient()
  }, [])

  const homeoPathyPendingPatient = () => {
    let url = `${API_URL.pendingPatient}?sewaType=${"9"}&fiscalYear=${DateUtils.getCurrentFiscalYear()}&registerConstant=${HOMEOPATHY}`
    AHMIS.get(url).then((response) => {
      let jsondata = response.data;
      setPendingPatientList(jsondata.data)
    })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  return (
    <>
      <Box marginTop={3}>
        <RegisterHeader
          registerTitle="होमियोप्याथी सेवा राजिस्टर"
          handleModalOpen={openHomeopathyModal}
          onHeaderParamChange={onHeaderParamChange}
          getRegisterData={getHomeoPathyData}
          lazyLoading
          showSearchField
          rightElement={<RegisterNotificationBell targetRegister={HOMEOPATHY} onAccept={handleNotificationAccept} />}
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showHomeoPathyModal}
        onModalSubmit={handleSubmit(submitHomeopathyRegister)}
        onModalClose={closeHomeopathyModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <MulDartaaSelect
            mulDartaaOptions={mulDartaaOptions}
            defaultValues={modalDefaultValues}
            register={register}
            handleSubmit={handleSubmit}
            setValue={setValue}
            errors={errors}
            watch={watch}
            registerConstant={HOMEOPATHY}
          />
        </Grid>
        <Box marginTop={2}>
          <Typography variant="h6">General Examination</Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="ICD Code"
                name="icdCode"
                onChange={handleCustomReactSelectChange}
                options={ICD_CODE_OPTIONS}
                defaultValue={modalDefaultValues?.icdCode}
                register={register}
                isMulti
                hasMultiLevelObject
                required
              />
              {errors?.icdCode && errors.icdCode?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="निदानात्मक परीक्षण"
                size="small"
                variant="outlined"
                name="diagnosticTest"
                autoComplete="true"
                defaultValue={modalDefaultValues?.diagnosticTest}
                fullWidth
                {...register("diagnosticTest")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="सम्भावित निदान  "
                size="small"
                variant="outlined"
                name="possibleDiagnosis"
                autoComplete="true"
                defaultValue={modalDefaultValues?.possibleDiagnosis}
                fullWidth
                {...register("possibleDiagnosis")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="उपचार र सल्लाह"
                size="small"
                variant="outlined"
                name="treatmentAndAdvice"
                autoComplete="true"
                defaultValue={modalDefaultValues?.treatmentAndAdvice}
                fullWidth
                {...register("treatmentAndAdvice")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="प्रेषण भई आएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredIn"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredIn}
                fullWidth
                {...register("referredIn")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="प्रेषण भई गएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredOut"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredOut}
                fullWidth
                {...register("referredOut")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <Tooltip title="लैङ्गिक हिंसा भए मात्र यो कोठामा चिन्ह लगाउनुहोस ।" placement="top" arrow>
                <Controller
                  name="genderViolence"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      label="लैङ्गिक हिंसा"
                      control={
                        <Checkbox {...field} checked={field.value} color="primary" />
                      }
                    />
                  )}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      </CustomModal>
      {
        pendingPatientList?.totalSize > 0 &&
        <Box mt={2}>
          <PendingPatientList
            pendingPatientList={pendingPatientList}
            showModal={setShowHomeoPathyModal}
            modalDefaultValues={setModalDefaultValues}
            setValue={setValue}
          />
        </Box>
      }
      <DeleteRegisterRecordConformation
        showDeleteModal={showHomeopathyDeleteModal}
        closeDeleteModel={closeHomeoPathyDeleteModal}
        deleteRecord={deleteHomeoPathyRow}
      />
      <HomeoPathySewaRegister
        onEditRow={HomeopathyEdit}
        tableData={homeoPathyDataTable}
        deleteRow={onDeleteHomeoPathyRow}
        totalSize={totalSize}
      />
    </>
  )
}

export default HomeoPathyForm
